export default function generateLocalFilenameFromUrl(url: string): string {
  return `.${new URL(url, "https://www.fakeurl.com").pathname}`;
}
